<template>
    <div class="parent-notification">
        <div v-html="$t('notification')" class="titleSchedule"/>
        <div style="display: flex; flex-direction: column;" v-for="(item, i) in items" :key="i" v-show="items.length">
            <notification-item :data="item"/>
        </div>
        <div  v-show="!items.length">Нет уведомлений</div>
    </div>
</template>

<script>
import NotificationItem from '@/components/notufication/NotificationItem.vue'

export default {
  name: 'Notification',
  components: { NotificationItem },
  data () {
    return {
      show: false,
      items: []
    }
  }
}
</script>

<style lang="scss" scoped>

.titleSchedule{
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 20px;
}
.parent-notification {
    padding: 25px;
    font-family: Helvetica, sans-serif;
}
</style>
